import { LoginRequiredOptions, useLoginRequiredContext } from '@/contexts/Common/LoginRequiredContext';

const useAuthRedirect = () => {
  const { showLoginRequired } = useLoginRequiredContext();

  const authRedirect = (redirectUrl?: string, options?: Omit<LoginRequiredOptions, 'redirectUrl'>) => {
    if (!localStorage.getItem('token')) {
      showLoginRequired({ ...options, redirectUrl });
      return false; // 로그인되어 있지 않음
    }

    return true; // 로그인되어 있음
  };

  return authRedirect;
};

export default useAuthRedirect;
